import React, { Fragment } from "react"

import PopdOrderNote from "./PopdOrderNote"
import PopdPlaceOrderButton from "./PopdPlaceOrderButton"
import PopdPaymentNote from "./PopdPaymentNote"
import PopdReceipts from "./PopdReceipts"
import classes from "./index.module.scss"
import PoLinkPayMethods from "./PoLinkPayMethods"

const PoPaymentDetails = props => {
  const {
    formErrors,
    setFormErrors,
    paymentDetails,
    setPaymentDetails,
    orderItems,
    orderCombos,
    customerInfo,
    setCustomerInfo,
    customerAddress,
    setCustomerAddress,
    initialFormErrorsState
  } = props

  return (
    <Fragment>
      <div className={classes["form"]}>
        <PopdOrderNote
          formErrors={formErrors}
          paymentDetails={paymentDetails}
          setPaymentDetails={setPaymentDetails}
        />

        <PopdPaymentNote
          formErrors={formErrors}
          paymentDetails={paymentDetails}
          setPaymentDetails={setPaymentDetails}
        />

        <PopdReceipts
          formErrors={formErrors}
          paymentDetails={paymentDetails}
          setPaymentDetails={setPaymentDetails}
        />

        <PoLinkPayMethods
          paymentDetails={paymentDetails}
          setPaymentDetails={setPaymentDetails}
        />
      </div>

      <PopdPlaceOrderButton
        setFormErrors={setFormErrors}
        paymentDetails={paymentDetails}
        orderItems={orderItems}
        orderCombos={orderCombos}
        customerInfo={customerInfo}
        setCustomerInfo={setCustomerInfo}
        customerAddress={customerAddress}
        setCustomerAddress={setCustomerAddress}
        initialFormErrorsState={initialFormErrorsState}
      />
    </Fragment>
  )
}

export default React.memo(PoPaymentDetails)